import { action, computed, observable, runInAction } from "mobx";
import { createContext } from "react";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { ITechnicianCertificateName } from "../models/techniciancertificatename";

class projectdashboardStore {
  @observable countStatus: {count: number, status: string}[]= [];
  @observable loadingInitial = false;

  @action loadProjectCounts = async (type: string) => {
    this.loadingInitial = true;
    this.countStatus.length = 0;
    this.countStatus.push({count: 0, status: 'Quotes Not Yet Submitted'});
    this.countStatus.push({count: 0, status: 'Orders Not Yet Accepted'});
    this.countStatus.push({count: 0, status: 'Work in Progress'});
    this.countStatus.push({count: 0, status: 'Variation Items Not Yet Submitted'});
    this.countStatus.push({count: 0, status: 'Customer Response to Variation Request'});
    this.countStatus.push({count: 0, status: 'Work Completed'});
    this.countStatus.push({count: 0, status: 'Work Submitted'});
    this.countStatus.push({count: 0, status: 'Progress Claim Request Disputed by Customer'});
    this.countStatus.push({count: 0, status: 'Orders Stopped'});
    this.countStatus.push({count: 0, status: 'Invoiced'});
    try {
      const listcounts = await agent.ProjectManagement.listCount(type);
      runInAction("loading project status count", () => {
        listcounts.forEach((listcount: any) => {
          let index = this.countStatus.findIndex((obj => obj.status === listcount.status));
          this.countStatus[index].count = listcount.count
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load project status count Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load project status count Error");
    }
  };

}

export default createContext(new projectdashboardStore());
